module.exports = __webpack_public_path__ + "assets/img/c_syf.31476849.png";